define.alias("shared/components/shared/ui/ember-drop", "media/components/shared/ui/ember-drop");